module.exports = __webpack_public_path__ + "static/media/gruendungpreis.e828c35a.png";